export default __webpack_public_path__ + "static/media/Picture1.084e20c9.png";